<script setup>
    import { definePageMeta, usePageEnter } from '#imports';
    import { PreloaderComplete, UserReady } from '@fanatics/resn-api/instant-rips';
    import { onMounted, ref } from 'vue';

    import MainScene from '~/components/gl/instant-rips/MainScene.vue';
    import PageWrapper from '~/components/PageWrapper.vue';
    import { useWindowMessage } from '~/composables/useWindowMessage';
    import { GlobalAssets } from '~/providers/GlobalAssets';
    import InstantRipsWrapper from '~/providers/instant-rips/InstantRipsWrapper.vue';

    const { sendMessage } = useWindowMessage();

    const refFanatics = ref(null);

    onMounted(() => {
        sendMessage(UserReady);
    });
    usePageEnter(() => {
        sendMessage(PreloaderComplete);
    });
</script>

<template>
    <PageWrapper>
        <InstantRipsWrapper>
            <GlobalAssets>
                <MainScene />
            </GlobalAssets>
        </InstantRipsWrapper>
    </PageWrapper>
</template>

<style lang="scss" scoped>
    @use '@/styles/shared.scss' as *;

    .page {
        @include fill;
        @include flexCenter;
        pointer-events: none;
    }
</style>
